'use client'

import dynamic from "next/dynamic";

const NotFoundWebsiteTenantHandler = dynamic(
  () => import("./not-found-website-tenant-handler"),
  { ssr: false }
);

export default function NotFoundClient() {
  return <NotFoundWebsiteTenantHandler />;
}
